module.exports = __webpack_public_path__ + "static/media/ppl.1288869c.png";